import ContentShowItem from "MiniSiteComponents/Carousel/Carousel.interface";
import { MediaItem } from "Interfaces/general.interface";
import { ContentShowListProps as Props } from 'MiniSiteComponents/ContentShow/ContentShow.interface';
import CustomLinkButton from 'GeneralComponents/CustomLinkButton';
import LimitedContent from 'GeneralComponents/LimitedContent';
import ComponentImage from 'GeneralComponents/ComponentImage';
import "./MessageBoard.min.css";
import { decodeHtmlEntities } from "../../../Interfaces/utils/Utils";

type ClassConfig = { classForContent: string, noShowForTitle: string };

const MessageBoardItem: React.FC<Props> = (props) => {

    const { componentId, items, noImagesClass, linkTarget } = props;

    function configureLimitedContentLines(item: ContentShowItem) {

        const is1200 = window.matchMedia("(min-width: 1200px)").matches;
        let noShowForTitle = "";
        let classForContent = "";

        if (!item.title && !item.richDescription && !item.icon && !item.image.url) {

            noShowForTitle = "none ";

            if (is1200) {
                if (!item.link.url && !item.url) classForContent = "line3"
                else classForContent = "line2"
            }

        }
        else if (is1200) {
            if (!item.link.url && !item.url) classForContent = "line3"
            else classForContent = "line2"
        }

        return {
            noShowForTitle,
            classForContent
        }

    }


    return (
        <ul className={`mst-Message-Board d-flex flex-wrap ${noImagesClass}`}
            id={"mst-content-list-" + componentId} >

            {
                items.map((item, idx) => {

                    const { richDescription, title, icon, image, mobileImage, url, link, content } = item;

                    const classConfig: ClassConfig = configureLimitedContentLines(item);
                    const hasIcon = !!icon;
                    const displayImg = !hasIcon && image.url;
                    const hasBothTitleAndSubtitle = title && richDescription;

                    return <li key={item.index} className="message-board-item">

                        <div className={classConfig.noShowForTitle + "title_contianer mb-2"}>

                            {
                                hasIcon &&
                                <div className="img_contianer">
                                    <i area-hidden="true" className={icon + " icon txt-pallete-color"}></i>
                                </div>
                            }  
                            {
                                displayImg &&
                                <ComponentImage
                                    image={image}
                                    imageClass="img"
                                    mobileImage={mobileImage}
                                    mobileImageClass="img"
                                    wrapperDivClass="img_contianer bg-pallete-color mb-0"
                                />
                            }

                            <div className={`titles_box justify-content-${hasBothTitleAndSubtitle ? 'between': 'center'}`}>

                                <h3 className={`title clamp ${hasBothTitleAndSubtitle? '': 'mb-0'}`}>{title}</h3>

                                <LimitedContent htmlContent={decodeHtmlEntities(richDescription)} classNames="sub_title clamp" clearHTML={true} />

                            </div>

                        </div>

                        {
                            // Content
                            content &&
                            <div className="description_placeholder">
                                    <LimitedContent
                                        htmlContent={content}
                                        classNames={classConfig.classForContent + " description clamp"}
                                    />
                            </div>
                        }

                        <div className="link_placeholder">
                            <CustomLinkButton
                                title={title || "" }
                                pageUrl={url}
                                link={link}
                                isBtn={false}
                                linkClass={"link txt-pallete-color clamp"}
                                dir={props.dir}
                                linkIcon={true}
                                charLimit={35}
                                linkTarget={props.linkTarget} />
                        </div>

                    </li>
                })
            }
            
        </ul>
    )
}

export default MessageBoardItem;